import type { QueryClient } from "@tanstack/react-query";
import { redirect } from "@tanstack/react-router";
import { z } from "zod";

import type { PromotionRequestRead } from "@/openapi";
import { listPromotionRequestsOptions } from "@/openapi/@tanstack/react-query.gen";

export const promotionReviewSearchSchema = z.object({
  status: z.enum(["pending", "approved"]).optional(),
});

export function preloadPromotionReviewQueue(
  queryClient: QueryClient,
  orgId: string,
  resourceType: PromotionRequestRead["resource_type"],
) {
  queryClient.query({
    ...listPromotionRequestsOptions({
      path: { org_id: orgId },
      query: { role: "approver", resource_type: resourceType },
    }),
    staleTime: "static",
  });
}

export function requireOrganizationId(orgId: string | undefined): string {
  if (!orgId) {
    throw redirect({ to: "/no-organization" });
  }
  return orgId;
}
